export enum StudyDesignStatus {
  applicable = 'applicable',
  notApplicable = 'notApplicable',
}
